export default __webpack_public_path__ + "static/Free-5a9c310345f4181571a360a512ef0e45.png";